import { createFeatureSelector, createSelector } from '@ngrx/store';
import { EStateStatus } from '@app/app.state';
import { IUserState } from './user.reducers';
export const selectUser = createFeatureSelector<IUserState>('userAdmin');
export const selectUserInfo = createSelector(selectUser, (state) => state.user);
export const selectUserId = createSelector(selectUser, (state) => state.id);
export const selectUserHasChanges = createSelector(
  selectUser,
  (state) => state.hasChanges,
);
export const selectUserIsLoading = createSelector(
  selectUser,
  (state) => state.status === EStateStatus.LOADING,
);
export const selectUserPageIsLoading = selectUserIsLoading;
export const selectUserError = createSelector(
  selectUser,
  (state) => state.error,
);
